import { ChevronRight, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { KIT } from "@/constants/testIds";
import { cn } from "@/lib/utils";

/** "You are here" for every screen. Each earlier step is tappable, the last one is where you are. */
export const Breadcrumbs = ({ items = [], className }) => {
  const navigate = useNavigate();
  if (!items.length) return null;

  return (
    <nav
      data-testid={KIT.breadcrumbs}
      aria-label="Breadcrumb"
      className={cn("flex flex-wrap items-center gap-x-1.5 gap-y-1 pb-1 pt-1", className)}
    >
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={`${item.label}-${i}`} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 shrink-0 text-brand-teal/30" />}
            {isLast || !item.to ? (
              <span
                aria-current={isLast ? "page" : undefined}
                className={cn(
                  "text-[14px] font-semibold",
                  isLast ? "text-brand-teal" : "text-brand-teal/55"
                )}
              >
                {item.label}
              </span>
            ) : (
              <button
                data-testid={KIT.breadcrumbLink(i)}
                onClick={() => navigate(item.to)}
                className="ps-tap inline-flex items-center gap-1.5 rounded-full text-[14px] font-semibold text-brand-teal/60 underline decoration-brand-teal/20 underline-offset-4 hover:text-brand-orangeInk hover:decoration-brand-orange/50"
              >
                {i === 0 && <Home className="h-3.5 w-3.5" />}
                {item.label}
              </button>
            )}
          </span>
        );
      })}
    </nav>
  );
};
